import { BaseBookingModel } from '@xeetr/types/models'

export const NoteColumn = (booking: BaseBookingModel) => booking.bookingAdditions?.note ?? ''
